import { combineReducers } from "redux";
import {
  PutMutipleAssignReducer,
  StatusAlertReducer,
  accountReducer,
  administratorReducer,
  agentActivityChartReducer,
  agentComissionEarningDashboardReducer,
  agentCustomersByIdDashboardReducer,
  agentDashboardReducer,
  agentDetailsReducer,
  agentReducer,
  agentTergetByIdDashboardReducer,
  agentTransactionByIdDashboardReducer,
  agentsPerformanceReducer,
  aggregatorDetailsReducer,
  aggregatorReducer,
  alertModalReducer,
  alertReducer,
  analysisUpdateReducer,
  areasReducer,
  bankReducer,
  bottomAgentRankReducer,
  cashoutReducer,
  closeSideBarReducer,
  commissionReducer,
  complaintDashboardReducer,
  coordinatorDetailsReducer,
  coordinatorReducer,
  coordinatorTypeReducer,
  customersReducer,
  dashboardReducer,
  daysCountReducer,
  earningDashboardReducer,
  fileReducer,
  financeTableReducer,
  floatFinanceDetails,
  genericReducer,
  getAchievementReducer,
  getAgentPerformanceDashboardReducer,
  getAggregatorByIdReducer,
  getAggregatorCountReducer,
  getAggregatorPerformanceDashboardReducer,
  getAggregatorPerformanceReducer,
  getAllAgentReducer,
  getAssignedReducer,
  getBillTypeReducer,
  getCommissionEarningFilterDashboardReducer,
  getFloatBalanceDashboardReducer,
  getFormStateReducer,
  getLGAReducer,
  getLocationReducer,
  getPerformanceAndCommissionsReducer,
  getPosMetricsDashboardReducer,
  getRegionsReducer,
  getStartedAndStoppedTerminalsReducer,
  getTradePartnerLocation,
  getUnAssignMessageReducer,
  getUnAssignReducer,
  getaggregatorPhoneNumberReducer,
  internalLoaderReducer,
  loaderReducer,
  logsDetailsReducer,
  logsReducer,
  menuReducer,
  modalReducer,
  notificationReducer,
  otpReducer,
  posAggregatorTransactionReducer,
  posTransactionsReducer,
  recAndDecSuccessMessage,
  recAndDeclineMessageReducer,
  recAndDeclineReducer,
  requestDashboardReducer,
  requestReducer,
  salesReducer,
  singleAdminReducer,
  statesReducer,
  superAggregatorAggregatorReducer,
  targetReducer,
  tellersReducer,
  terminalReducer,
  transactionCountDashboardSummaryReducer,
  transactionDashboardCountReducer,
  transactionDashboardReducer,
  transactionDetailsMessageReducer,
  transactionDetailsReducer,
  transactionDetailsStatusReducer,
  transactionReducer,
  transactionTypeReducer,
  userTypeReducer,
  verifyOtpReducer
} from "./appReducer";
import {
  authReducer,
  loginReducer,
  regionStateReducer,
  regionTerritoryReducer,
  tokenReducer,
  userReducer,
} from "./userReducer";

const rootReducer = combineReducers({
  // theme: themeReducer,
  loading: loaderReducer,
  internalLoader: internalLoaderReducer,
  auth: authReducer,
  menu: menuReducer,
  user: userReducer,
  tokens: tokenReducer,
  login: loginReducer,
  modal: modalReducer,
  alert: alertReducer,
  modalAlert: alertModalReducer,
  dashboard: dashboardReducer,
  agents: agentReducer,
  states: statesReducer,
  areas: areasReducer,
  file: fileReducer,
  statusAlert: StatusAlertReducer,
  terminals: terminalReducer,
  requests: requestReducer,
  transactions: transactionReducer,
  transactionsDetails: transactionDetailsReducer,
  commissions: commissionReducer,
  cashout: cashoutReducer,
  accounts: accountReducer,
  agentDetails: agentDetailsReducer,
  customers: customersReducer,
  tellers: tellersReducer,
  logs: logsReducer,
  logsDetails: logsDetailsReducer,
  transactionTypes: transactionTypeReducer,
  notification: notificationReducer,
  posTransactions: posTransactionsReducer,
  sales: salesReducer,
  complaintDashboard: complaintDashboardReducer,
  transactionDashboard: transactionDashboardReducer,
  transactionDashboardCount: transactionDashboardCountReducer,
  earningDashboard: earningDashboardReducer,
  agentDashboard: agentDashboardReducer,
  target: targetReducer,
  coordinator: coordinatorReducer,
  coordinatorDetails: coordinatorDetailsReducer,
  aggregators: aggregatorReducer,
  aggregatorDetails: aggregatorDetailsReducer,
  userType: userTypeReducer,
  coordinatorType: coordinatorTypeReducer,
  banks: bankReducer,
  generic: genericReducer,
  floatFinance: financeTableReducer,
  recAndDecline: recAndDeclineReducer,
  recAndDeclineMessageReducer: recAndDeclineMessageReducer,
  daysCountReducer: daysCountReducer,
  transactionDetailsStatusReducer: transactionDetailsStatusReducer,
  agentComissionEarningDashboardReducer: agentComissionEarningDashboardReducer,
  floatFinanceDetails: floatFinanceDetails,
  recAndDecSuccessMessage: recAndDecSuccessMessage,
  requestDashboardReducer: requestDashboardReducer,
  closeSidebarReducer: closeSideBarReducer,
  transactionDetailsMessageReducer: transactionDetailsMessageReducer,
  getTradePartnerLocation: getTradePartnerLocation,
  agentTergetByIdDashboardReducer: agentTergetByIdDashboardReducer,
  agentTransactionByIdDashboardReducer: agentTransactionByIdDashboardReducer,
  agentCustomersByIdDashboardReducer: agentCustomersByIdDashboardReducer,
  posAggregatorTransactionReducer: posAggregatorTransactionReducer,
  transactionCountDashboardSummary: transactionCountDashboardSummaryReducer,
  agentActivityChart: agentActivityChartReducer,

  bottomAgentRank: bottomAgentRankReducer,
  analysisUpdate: analysisUpdateReducer,
  agentPerformanceList: agentsPerformanceReducer,
  getAllegents: getAllAgentReducer,
  getAggregatorPerformance: getAggregatorPerformanceReducer,
  getBillType: getBillTypeReducer,
  getRegions: getRegionsReducer,
  regionState: regionStateReducer,
  regionTerritory: regionTerritoryReducer,
  getAggregatorCount: getAggregatorCountReducer,
  getAssigned: getAssignedReducer,
  PutMutipleAssign: PutMutipleAssignReducer,
  getUnAssignReducer: getUnAssignReducer,
  getUnAssignMessage: getUnAssignMessageReducer,
  getaggregatorPhoneNumber: getaggregatorPhoneNumberReducer,
  administrators: administratorReducer,
  singleAdmin: singleAdminReducer,
  superAggregatorAggregator: superAggregatorAggregatorReducer,
  getAssignedReducer: getAssignedReducer,
  getStartedAndStoppedTerminals: getStartedAndStoppedTerminalsReducer,
  getAchievement: getAchievementReducer,
  getLocation: getLocationReducer,
  getAggregatorById: getAggregatorByIdReducer,
  getFormState: getFormStateReducer,
  getLGAS: getLGAReducer,
  getPerformanceAndCommissions: getPerformanceAndCommissionsReducer,
  getAgentPerformanceDashboard: getAgentPerformanceDashboardReducer,
  getAggregatorPerformanceDashboard: getAggregatorPerformanceDashboardReducer,
  getPosMetricsDashboard: getPosMetricsDashboardReducer,
  getCommissionEarningFilterDashboard:
    getCommissionEarningFilterDashboardReducer,
  getFloatBalanceDashboard: getFloatBalanceDashboardReducer,
  otp: otpReducer,
  verifyOtp: verifyOtpReducer,
});

export default rootReducer;
